// This module fixes behavior in stand-alone FEP where if you logged out & then hit the "Back" button in your browser...
// ...you were still able to edit user profile
// There's a URL check to make sure this doesn't have any effect on portals
// Portals don't have this issue, it's stand-alone FEP only

export default class EditProfileAccess implements IDigitalIdentityHubModule {
  public name = "EditProfileAccess";

  public init(): void { /* No functionality */ }

  public ready(): void {
    janrain.events.onCaptureSessionNotFound.addHandler(function() {
      janrain.events.onCaptureRenderComplete.addHandler(result => {
        if (result.screen === "editProfile" &&
          (document.URL.indexOf("localhost") > -1 || document.URL.indexOf("dmc-front-end-package") > -1)) {
          if (!localStorage.getItem("janrainAccessToken")) {
            console.log("Access denied. Redirecting to login page.");
            janrain.capture.ui.renderScreen("signIn");
          }
        }
      });
    });

    const submitButton = document.getElementsByClassName("dih__edit-profile__information__form-actions")[0]
      ?.querySelectorAll('input[type="submit"]')[0] as HTMLInputElement;

    if (document.URL.indexOf("localhost") > -1 || document.URL.indexOf("dmc-front-end-package")) {
      if (document.URL.indexOf("editProfile") > -1) {
        submitButton.addEventListener("click", e => {
          if (!localStorage.getItem("janrainCaptureToken")) {
            e.preventDefault();
            e.stopPropagation();
            console.log("Access denied. Redirecting to login page.");
            janrain.capture.ui.renderScreen("signIn");
            window.location.href = window.DigitalIdentityHub.settings.htmlTokens.loginPath;
          }
        });
      }
    }
  }
}
